import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  OptimizationCloneListResponse,
  RunCloneRequest,
  RunCloneResponse,
} from './types';

export const QUERY_KEYS = {
  list: ['optimization-detail-navigation', 'list'] as const,
};

export function useOptimizationCloneList() {
  return useQuery({
    queryKey: QUERY_KEYS.list,
    queryFn: async () => {
      const response = await fetch('/api/optimization-detail-navigation/list');
      if (!response.ok) {
        throw new Error('Impossible de charger la liste des optimisations.');
      }
      return response.json() as Promise<OptimizationCloneListResponse>;
    },
  });
}

export function useRunOptimizationClone() {
  return useMutation({
    mutationFn: async (payload: RunCloneRequest) => {
      const response = await fetch('/api/optimization-detail-navigation/run', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Impossible de lancer l'optimisation clonée.");
      }

      return response.json() as Promise<RunCloneResponse>;
    },
  });
}
